import React, { useState, useEffect, useRef } from 'react';
import { Card, CardBody, CardHeader, CardTitle, Row, Col, Button, Badge, Input, FormGroup, Label } from 'reactstrap';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloudUploadAlt } from "@fortawesome/free-solid-svg-icons";
import { faWindowClose } from '@fortawesome/free-solid-svg-icons';
import ProactiveMonitoringTasks from './ProactiveMonitoringSubComponents/ProactiveMonitoringTasks';
import ProactiveMonitoringOtherTypes from './ProactiveMonitoringSubComponents/ProactiveMonitoringOtherTypes';
import ProactiveMonitoringNotifications from './ProactiveMonitoringSubComponents/ProactiveMonitoringNotifications';
import ProactiveMonitoringTickets from './ProactiveMonitoringSubComponents/ProactiveMonitoringTickets';
import TransformedAlertsSaveDataService from '../../../../../../Service/OPSServices/ProactiveMonitoringServices/TransformedAlertsSaveDataService';
import FetchAllAmazonAlertsService from '../../../../../../Service/OPSServices/ProactiveMonitoringServices/FetchAllAmazonAlertsService';
import LoadingOverlay from 'react-loading-overlay';
import Loader from "react-loaders";
import BulkCreationActionsService from '../../../../../../Service/OPSServices/ProactiveMonitoringServices/BulkCreationActionsService';
import CustomModal from '../../../../../Components/Modals/CustomModal';
import notify from "../../../../../../Notifications/ToastifyActions";
import NotificationSettings from './ProactiveMonitoringSubComponents/NotificationSettings';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import GridPagination from '../../../../../Components/Pagination/GridPagination';
import FilterAmazonAlertService from '../../../../../../Service/OPSServices/ProactiveMonitoringServices/FilterAmazonAlertService';
import AmazonNotificationsMainPage from '../../../AmazonNotifications/AmazonNotificationsMainPage';

function ProactiveMonitoringMainPage(props) {
    const [alerts, setAlerts] = useState([]);
    const [showImportForm, setShowImportForm] = useState(false);
    const [jsonInput, setJsonInput] = useState('');
    const [selectedFile, setSelectedFile] = useState([]);
    const [importMethod, setImportMethod] = useState('text');
    const [showStoreNameColumn, setShowStoreNameColumn] = useState(false);
    const [activeTab, setActiveTab] = useState("today");
    const [allAmazonAlertsData, setAllAmazonAlertsData] = useState()
    const [page, setPage] = useState(1);
    const [pageSize] = useState(10000);
    const [globalSearch, setGlobalSearch] = useState("");
    const [pagination, setPagination] = useState({ page: 1, pageSize: 10000, totalCount: 0, totalPages: 0 });
    const [problemAreaList, setProblemAreaList] = useState([]);
    const [subRequestTypesList, setSubRequestTypesList] = useState([]);
    const [problemAreaPathwayList, setProblemAreaPathwayList] = useState([]);
    const [ticketsData, setTicketsData] = useState([]);
    const [tasksData, setTasksData] = useState([]);
    const [notificationsData, setNotificationsData] = useState([]);
    const [newTypeData, setNewTypeData] = useState([]);
    const [teamMembers, setTeamMembers] = useState([]);
    const [loadScreen, setLoadScreen] = useState(false);
    const [loggedInUserId, setLoggedInUserId] = useState(null)
    const [notificationStatistics, setNotificationStatistics] = useState()
    const [bulkCreateConfirmationsPopup, setBulkCreateConfirmationsPopup] = useState(false);
    const [counts, setCounts] = useState([]);
    const [alreadyCreatedCounts, setAlreadyCreatedCounts] = useState([]);
    const [unSatisfiedTicketActions, setUnSatisfiedTicketActions] = useState(0)
    const [openNotificationSetting, setOpenNotificationSetting] = useState(false)
    const newTypesRef = useRef(null);
    const ticketsRef = useRef(null);
    const tasksRef = useRef(null);
    const notificationsRef = useRef(null);
    const [importResultModal, setImportResultModal] = useState(false);
    const [importResultDetails, setImportResultDetails] = useState({ title: '', messages: [], type: 'info' });
    const [shouldReloadOnClose, setShouldReloadOnClose] = useState(false);
    const [selectedBox, setSelectedBox] = useState('total');
    const [fileErrorMessage, setFileErrorMessage] = useState('');
    const [allNotificationSettings, setAllNotificationSettings] = useState([]);
    const [showAmazonNotifications, setShowAmazonNotifications] = useState(false);
    const [selectedModule, setSelectedModule] = useState("selleros");

    const validateAndFilterFiles = (newFiles) => {
        const allowedExtensions = ['json'];
        const maxSize = 5 * 1024 * 1024; // 5MB
        const validFiles = [];
        const invalidFileNames = [];
        const duplicateFileNames = [];

        newFiles.forEach(file => {
            const extension = file.name.split('.').pop().toLowerCase();
            const isValidType = allowedExtensions.includes(extension) || file.type === 'application/json';
            const isValidSize = file.size <= maxSize;

            // Check if file already exists in the selectedFile state
            const isDuplicate = selectedFile.some(
                (existingFile) => existingFile.name === file.name && existingFile.size === file.size
            );

            if (isDuplicate) {
                duplicateFileNames.push(file.name);
            } else if (isValidType && isValidSize) {
                validFiles.push(file);
            } else {
                invalidFileNames.push(file.name);
            }
        });

        // Handle Error Messages
        let errorMsg = '';
        if (invalidFileNames.length > 0) {
            errorMsg += `Invalid file(s) ignored: ${invalidFileNames.join(', ')}. Only JSON under 5MB allowed. `;
        }
        if (duplicateFileNames.length > 0) {
            errorMsg += `Duplicate file(s) ignored: ${duplicateFileNames.join(', ')}.`;
        }

        setFileErrorMessage(errorMsg);
        return validFiles;
    };
    const handleCloseImportResult = () => {
        setImportResultModal(false);
        if (shouldReloadOnClose) {
            window.location.reload();
        }
    };

    const handleStatClick = (type) => {
        setSelectedBox(type);

        const map = {
            total: newTypesRef,
            newType: newTypesRef,
            tickets: ticketsRef,
            tasks: tasksRef,
            notifications: notificationsRef
        };

        setTimeout(() => {
            const ref = map[type];
            if (ref && ref.current) {
                ref.current.scrollIntoView({ behavior: 'smooth' });
            }
        }, 100);
    };

    const fetchAlerts = () => {
        setLoadScreen(true);
        const data = { activeTab, page, pageSize };

        FetchAllAmazonAlertsService(props.token, data).then((res) => {
            if (res) {
                console.log(res)
                const allAlerts = res.AllAmazonAlertsData || [];
                const pager = res.pagination || {};
                setPagination({
                    page: pager.page || page,
                    pageSize: pager.pageSize || pageSize,
                    totalCount: pager.totalCount || 0,
                    totalPages: pager.totalPages || 0,
                });
                setNotificationStatistics(res.notificationStatistics);
                setAllAmazonAlertsData(allAlerts);
                setProblemAreaList(Array.isArray(res.problemAreaList) ? res.problemAreaList : []);
                setSubRequestTypesList(Array.isArray(res.subRequestTypes) ? res.subRequestTypes : []);
                setProblemAreaPathwayList(Array.isArray(res.problemAreaPathwayList) ? res.problemAreaPathwayList : []);
                setTeamMembers(res.teamMembers || []);


                // Changed filter to include 'Created' along with 'New'

                // Changed filter to include 'Created' along with 'New'
                const tickets = allAlerts.filter(a => a.proactive_action === 1 && (a.status == 'New' || a.status == 'Created')).map(alert => ({
                    ...alert,
                    // Ensure we map the saved ID from DB if it exists
                    problemAreaId: alert.problemAreaId ? alert.problemAreaId : "",
                    problemAreaPathwayId: alert.problemAreaPathwayId ? alert.problemAreaPathwayId : "",
                    requestSubTypeId: alert.requestSubTypeId ? alert.requestSubTypeId : ""
                }));

                const tasks = allAlerts.filter(a => a.proactive_action === 2 && (a.status == 'New' || a.status == 'Created'));
                const notifications = allAlerts.filter(a => a.proactive_action === 3 && (a.status == 'New' || a.status == 'Created'));
                const newType = allAlerts.filter(a => a.proactive_action === null);

                setTicketsData(tickets);
                setTasksData(tasks);
                setNotificationsData(notifications);
                setNewTypeData(newType);
                setLoggedInUserId(res.loggedInUserId);

                const created = res.alreadyCreatedCounts || {};
                setAlreadyCreatedCounts({
                    tickets: Number(created.tickets) || 0,
                    tasks: Number(created.tasks) || 0,
                    notifications: Number(created.notifications) || 0,
                    total: Number(created.total) || 0,
                });

                const ready = res.counts || {};
                setCounts({
                    tickets: Number(ready.tickets) || 0,
                    tasks: Number(ready.tasks) || 0,
                    notifications: Number(ready.notifications) || 0,
                    newType: Number(ready.newType) || 0,
                });
            }
            setLoadScreen(false);
        }).catch(err => {
            console.error(err);
            setLoadScreen(false);
            toast.error("Failed to fetch alerts");
        });
    };


    // Update useEffect to use this function

    // Update useEffect to use this function
    useEffect(() => {
        fetchAlerts();
    }, [props.token, activeTab, page, pageSize]);
    // 1.Select Multiple Files & Check State
    const handleFileSelect = (event) => {
        if (!event || !event.target || !event.target.files) return;
        const files = Array.from(event.target.files);
        const filtered = validateAndFilterFiles(files);

        // Append new valid files to existing ones (or replace, depending on preference)
        setSelectedFile(prev => [...prev, ...filtered]);

        // Reset input so the same file can be picked again if removed
        event.target.value = "";
    };

    // If you add a div for Drag & Drop in your UI (like the reference code):
    const handleDrop = (e) => {
        e.preventDefault();
        const files = Array.from(e.dataTransfer.files);
        const filtered = validateAndFilterFiles(files);
        setSelectedFile(prev => [...prev, ...filtered]);
    };

    // 2.The Upload Logic for Multiple Files
    const handleFileUpload = async () => {
        if (!selectedFile || selectedFile.length === 0) {
            setFileErrorMessage("Please select at least one valid JSON file.");
            return;
        }

        const readFileAsJson = (file) => {
            return new Promise((resolve) => {
                const reader = new FileReader();
                reader.onload = (e) => {
                    try {
                        const jsonContent = JSON.parse(e.target.result);
                        if (jsonContent && Array.isArray(jsonContent.notifications)) {
                            jsonContent.notifications = jsonContent.notifications.map(n => ({
                                ...n,
                                file_name: file.name
                            }));
                        }
                        resolve({ success: true, data: jsonContent });
                    } catch (error) {
                        resolve({ success: false, fileName: file.name, error: "Invalid JSON syntax" });
                    }
                };
                reader.readAsText(file);
            });
        };

        try {
            const results = await Promise.all(selectedFile.map(readFileAsJson));
            const failedFiles = results.filter(r => !r.success);
            const successfulData = results.filter(r => r.success).map(r => r.data);

            if (failedFiles.length > 0) {
                // Grouping logic for the specific UI request
                const errorList = failedFiles.map(f => `• ${f.fileName}`);

                setImportResultDetails({
                    title: 'Parsing Errors Found',
                    messages: [
                        `The following ${failedFiles.length} file(s) could not be parsed:`,
                        `Invalid JSON syntax:`, // Header for the specific error
                        ...errorList,
                        successfulData.length > 0
                            ? `Remaining ${successfulData.length} valid file(s) were NOT processed. Please fix the errors.`
                            : ""
                    ].filter(m => m !== ""),
                    type: 'error'
                });
                setImportResultModal(true);
                return;
            }

            // Proceed with combined data if all files are valid
            let combinedData = [];
            successfulData.forEach(data => {
                if (Array.isArray(data)) combinedData = [...combinedData, ...data];
                else combinedData.push(data);
            });

            processImportedData(combinedData);

        } catch (error) {
            setImportResultDetails({
                title: 'Processing Error',
                messages: ["An unexpected error occurred during file reading."],
                type: 'error'
            });
            setImportResultModal(true);
        }
    };

    // 3.The Button Click Handler
    const handleJsonImport = () => {
        // Reset error message at the start of the attempt
        setFileErrorMessage("");

        if (importMethod === 'file') {
            // CASE 1: File Upload Mode
            if (!selectedFile || selectedFile.length === 0) {
                setFileErrorMessage("Please select at least one valid JSON file.");
                return;
            }
            handleFileUpload();
        } else {
            // CASE 2: Text Paste Mode
            if (!jsonInput || jsonInput.trim() === '') {
                setFileErrorMessage("Please paste JSON data before importing.");
                return;
            }
            try {
                const parsedData = JSON.parse(jsonInput);
                processImportedData(parsedData);
            } catch (error) {
                setImportResultDetails({
                    title: 'JSON Parse Error',
                    messages: [`Invalid JSON format: ${error.message}`],
                    type: 'error'
                });
                setImportResultModal(true);
            }
        }
    };

    const processImportedData = async (parsedData) => {
        let normalizedData = [];

        // Handle object-root JSON, OLD flat format, grouped format logic
        if (!Array.isArray(parsedData) && parsedData.notifications) {
            parsedData = [parsedData];
        }
        if (Array.isArray(parsedData) && parsedData[0] && parsedData[0].asin) {
            normalizedData = parsedData;
        }
        else if (Array.isArray(parsedData) && parsedData[0] && parsedData[0].notifications) {
            parsedData.forEach(group => {
                group.notifications.forEach(notification => {
                    normalizedData.push({
                        asin: notification.asin ? notification.asin : null,
                        market: notification.market ? notification.market : null,
                        profileId: null,
                        source: notification ? notification.source : '',
                        file_name: notification ? notification.file_name : '',
                        type: notification.type ? notification.type : null,
                        old_value: notification.old_value !== undefined ? notification.old_value : null,
                        new_value: notification.new_value !== undefined ? notification.new_value : null
                    });
                });
            });
        }
        else {
            // ERROR: Unsupported Structure
            setImportResultDetails({
                title: 'Structure Error',
                messages: ['Unsupported JSON structure. Could not find valid notification data.'],
                type: 'error'
            });
            setImportResultModal(true);
            return;
        }

        if (!normalizedData.length) {
            // WARNING: No Data
            setImportResultDetails({
                title: 'No Data Found',
                messages: ['No valid alerts found in the provided data.'],
                type: 'warning'
            });
            setImportResultModal(true);
            return;
        }


        const transformedAlerts = [];
        let alertId = alerts.length + 1;

        normalizedData.forEach(item => {
            transformedAlerts.push({
                id: alertId++,
                asin: item.asin,
                source: item.source,
                fileName: item.file_name,
                market: item.market,
                profileId: item.profileId,
                type: item.type,
                old_value: item.old_value,
                new_value: item.new_value,
                proactive_action: null,
                status: 'New',
                created_at: new Date().toISOString(),
                problemAreaId: null,
                problemAreaPathwayId: null,
                requestSubTypeId: null,
                original_data: item
            });
        });

        // Clear UI state immediately
        setJsonInput('');
        setSelectedFile([]);
        setShowImportForm(false);

        // Show a loading state if needed, but DO NOT show success toast yet
        setLoadScreen(true);

        // Call the service
        try {
            const res = await TransformedAlertsSaveDataService(
                props.token,
                transformedAlerts,
                selectedFile
            );

            if (res && res.success) {
                const created = res.created_count;
                const duplicates = res.duplicate_count;

                // CASE 1: Pure success → reload immediately
                if (created > 0 && duplicates === 0) {
                    setTimeout(() => {
                        window.location.reload();
                    }, 900);
                    return;
                }

                // CASE 2: Partial success / duplicates → show modal
                let messages = [];
                let title = "Import Status";
                let type = "info";

                if (created > 0) {
                    title = "Import Partially Successful";
                    type = "success";
                    messages.push(`Successfully imported ${created} new alerts.`);
                    setShouldReloadOnClose(true);
                }

                if (duplicates > 0) {
                    if (created === 0) {
                        title = "Duplicate Data Found";
                        type = "info";
                        setShouldReloadOnClose(true);
                    }
                    messages.push(`${duplicates} alert(s) were skipped because they already exist.`);
                }

                if (created === 0 && duplicates === 0) {
                    title = "Import Failed";
                    type = "error";
                    messages.push("No data was saved to the database. Please check the file content.");
                }

                setImportResultDetails({ title, messages, type });
                setImportResultModal(true);
            }


            else {
                setImportResultDetails({
                    title: 'Server Error',
                    messages: ["Failed to save data to the server."],
                    type: 'error'
                });
                setImportResultModal(true);
            }
        }
        catch (e) {
            // ❌ Should never reach here if service handles errors
            setLoadScreen(false);
        }
    };

    const clearImportForm = () => {
        setJsonInput('');
        setSelectedFile([]);
        setImportMethod('text');
        setShowImportForm(false);
    };

    const formatFileSize = (bytes) => {
        if (bytes === 0) return '0 KB';
        const k = 1024;

        // If file is smaller than 1024 bytes, convert to fractional KB immediately
        if (bytes < k) {
            return (bytes / k).toFixed(2) + ' KB';
        }

        // Standard logic for 1 KB and up
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    };

    // Function to remove a specific file from the list
    const removeFile = (indexToRemove) => {
        const updatedFiles = selectedFile.filter((_, index) => index !== indexToRemove);
        setSelectedFile(updatedFiles);
        // Reset the actual file input if all files are removed
        if (updatedFiles.length === 0) {
            const fileInput = document.getElementById('fileInput');
            if (fileInput) fileInput.value = "";
        }
    };
    const handleConfrimationPopup = () => {
        // 1. Calculate the bad tickets (Missing info)
        const invalidTickets = ticketsData && ticketsData.filter(ticket => ticket.requestSubTypeId == '' && ticket.status !== 'Created');

        // 2. Update the count state for the UI
        setUnSatisfiedTicketActions(invalidTickets.length);

        // 3. Open the popup (DO NOT setTicketsData here)
        setBulkCreateConfirmationsPopup(true);
    };
    const handleNotificationSetting = () => {
        setOpenNotificationSetting(true)

    }

    const handleBulkCreation = () => {
        setLoadScreen(true);
        setBulkCreateConfirmationsPopup(false);

        let finalTicketCollection = [];

        // 1. Get all New tickets
        const allNewTickets = ticketsData.filter(t => t.status === 'New');

        // 2. Apply Logic based on user selection in Popup

        finalTicketCollection = allNewTickets;

        let data = {
            ticketCollection: finalTicketCollection,
            notificationCollection: notificationsData.filter(n => n.status === 'New'),
            taskCollection: tasksData.filter(t => t.status === 'New')
        };

        BulkCreationActionsService(props.token, data)
            .then((res) => {
                setLoadScreen(false);
                if (res) {
                    window.location.reload();
                }
            });
    };

    const handleTableFieldChange = (rowId, field, value) => {


        setTicketsData(prev => {
            const arr = Array.isArray(prev) ? prev : [];

            return arr.map((r) => {
                if (r.id !== rowId) return r;

                if (field === "problemAreaId") {
                    return {
                        ...r,
                        problemAreaId: value,
                        problemAreaPathwayId: "",
                        requestSubTypeId: "",
                    };
                }

                if (field === "problemAreaPathwayId") {
                    return {
                        ...r,
                        problemAreaPathwayId: value,
                        requestSubTypeId: "",
                    };
                }

                if (field === "requestSubTypeId") {
                    return {
                        ...r,
                        requestSubTypeId: value,
                    };
                }

                return { ...r, [field]: value };
            });
        });
    };



    const handleSearchAction = () => {
        let data = {
            search: globalSearch,
            activeTab,
            page,
            pageSize,
        };

        setLoadScreen(true);
        if (globalSearch.trim() === "") {
            fetchAlerts();   // Fetch all records for the selected activeTab
            return;
        }

        FilterAmazonAlertService(props.token, data)
            .then((res) => {
                setLoadScreen(false);

                if (res) {
                    console.log(res)
                    const allAlerts = res.data.AllAmazonAlertsData || [];
            
                    setAllAmazonAlertsData(allAlerts);
            
                    setTicketsData(
                        allAlerts.filter(
                            a => a.proactive_action === 1 &&
                            (a.status === "New" || a.status === "Created")
                        )
                    );
            
                    setTasksData(
                        allAlerts.filter(
                            a => a.proactive_action === 2 &&
                            (a.status === "New" || a.status === "Created")
                        )
                    );
            
                    setNotificationsData(
                        allAlerts.filter(
                            a => a.proactive_action === 3 &&
                            (a.status === "New" || a.status === "Created")
                        )
                    );
            
                    setNewTypeData(
                        allAlerts.filter(a => a.proactive_action === null)
                    );
            
                    const pager = res.pagination || {};

                    setPagination({
                        page: pager.page || 1,
                        pageSize: pager.pageSize || pageSize,
                        totalCount: pager.totalCount || 0,
                        totalPages: pager.totalPages || 0,
                    });
                }
            })
            
    };

    //   AmazonNotificationsMainPage
    if (showAmazonNotifications) {
        return (
            <AmazonNotificationsMainPage
                onBackHeader={() => {
                    setShowAmazonNotifications(false);
                    setSelectedModule("selleros");
                }}
            />
        );
    }

    return (
        <div className="proactive-monitoring-page">

            {/* FIXED HEADER SECTION (Tabs + Stats) */}
            <div className="proactive-monitoring">
            <Row className="mt-3 mb-2">
                <Col md={12}>
                <div className="proactive-header">

                        <div className="proactive-header-title">
                            Seller Sonar
                        </div>

                        <button
                            type="button"
                            className="amazon-notifications-button"
                            onClick={() => {
                                setSelectedModule("amazon");
                                setShowAmazonNotifications(true);
                            }}
                        >
                            Go to Amazon Notifications
                        </button>
                    </div>
                </Col>
            </Row>

            {selectedModule === "selleros" && (
                <Row className="mt-3 mb-3">
                    <Col>
                        <div className="brand-tabs d-flex align-items-center">
                            <div
                                className={`main-tabs ${activeTab === "today" ? "active" : ""}`}
                                onClick={() => { setActiveTab("today"); setPage(1); setGlobalSearch('')}}
                            >
                                Today's Jobs
                            </div>
                            <div
                                className={`main-tabs ${activeTab === "pending" ? "active" : ""}`}
                                onClick={() => { setActiveTab("pending"); setPage(1);setGlobalSearch('') }}
                            >
                                Pending Jobs
                            </div>
                            <div
                                className={`main-tabs ${activeTab === "complete" ? "active" : ""}`}
                                onClick={() => { setActiveTab("complete"); setPage(1);setGlobalSearch('') }}
                            >
                                Completed Jobs
                            </div>
                            <div className="ml-auto d-flex gap-2">
                                {!["pending", "complete"].includes(activeTab) && (
                                    <Button
                                        className="btn-background-color-Proceed-gallery"
                                        size="lg"
                                        onClick={() => setShowImportForm(true)}
                                    >
                                        Import JSON
                                    </Button>
                                )}
                                {!["complete"].includes(activeTab) && (
                                    <Button
                                        className="ml-2 btn-background-color-action-settings mr-2"
                                        onClick={handleNotificationSetting}
                                        disabled={props.activeTab && props.activeTab == 'complete'}
                                    >
                                        Action Settings
                                    </Button>
                                )}
                            </div>
                        </div>
                    </Col>
                </Row>
                )}


                <Row>
                    <Col>
                        <Card className="mb-2">
                            <Row>
                                <Col md={12}>
                                    <CardTitle className="border mb-0 p-2 text-center notification-status-title">
                                        PM Job Statistics
                                    </CardTitle>

                                    {activeTab == 'today' ?
                                        <div className="d-flex border p-1 justify-content-around">
                                            <div className={`notification-status-box ${selectedBox === 'total' ? 'selected' : ''}`} onClick={() => handleStatClick('total')}>
                                                <h5 className="proactive-total-notifications"><b>Total Alerts</b></h5>
                                                <h4 className="proactive-total-notifications"><b>{notificationStatistics ? notificationStatistics.today.total : 0}</b></h4>
                                            </div>
                                            <div className={`notification-status-box ${selectedBox === 'tickets' ? 'selected' : ''}`} onClick={() => handleStatClick('tickets')}>
                                                <h5 className="proactive-tickets"><b>Tickets</b></h5>
                                                <h4 className="proactive-tickets"><b>{notificationStatistics ? (notificationStatistics.today.by_action.Ticket || 0) : 0}</b></h4>
                                            </div>
                                            <div className={`notification-status-box ${selectedBox === 'tasks' ? 'selected' : ''}`} onClick={() => handleStatClick('tasks')}>
                                                <h5 className="proactive-tasks"><b>Tasks</b></h5>
                                                <h4 className="proactive-tasks"><b>{notificationStatistics ? (notificationStatistics.today.by_action.Task || 0) : 0}</b></h4>
                                            </div>
                                            <div className={`notification-status-box ${selectedBox === 'notifications' ? 'selected' : ''}`} onClick={() => handleStatClick('notifications')}>
                                                <h5 className="proactive-notifications"><b>Notifications</b></h5>
                                                <h4 className="proactive-notifications"><b>{notificationStatistics ? (notificationStatistics.today.by_action.Notifications || 0) : 0}</b></h4>
                                            </div>
                                            <div className={`notification-status-box ${selectedBox === 'newType' ? 'selected' : ''}`} onClick={() => handleStatClick('newType')}>
                                                <h5 className="proactive-new-types"><b>New Types</b></h5>
                                                <h4 className="proactive-new-types"><b>{notificationStatistics ? (notificationStatistics.today.by_action.NewAction || 0) : 0}</b></h4>
                                            </div>
                                        </div>
                                        : activeTab == 'pending' ?
                                            <div className="d-flex border p-1 justify-content-around">
                                                <div className={`notification-status-box ${selectedBox === 'total' ? 'selected' : ''}`} onClick={() => handleStatClick('total')}>
                                                    <h5 className="proactive-total-notifications"><b>Total Alerts</b></h5>
                                                    <h4 className="proactive-total-notifications"><b>{notificationStatistics ? notificationStatistics.pending.total : 0}</b></h4>
                                                </div>
                                                <div className={`notification-status-box ${selectedBox === 'tickets' ? 'selected' : ''}`} onClick={() => handleStatClick('tickets')}>
                                                    <h5 className="proactive-tickets"><b>Tickets</b></h5>
                                                    <h4 className="proactive-tickets"><b>{notificationStatistics ? (notificationStatistics.pending.by_action.Ticket || 0) : 0}</b></h4>
                                                </div>
                                                <div className={`notification-status-box ${selectedBox === 'tasks' ? 'selected' : ''}`} onClick={() => handleStatClick('tasks')}>
                                                    <h5 className="proactive-tasks"><b>Tasks</b></h5>
                                                    <h4 className="proactive-tasks"><b>{notificationStatistics ? (notificationStatistics.pending.by_action.Task || 0) : 0}</b></h4>
                                                </div>
                                                <div className={`notification-status-box ${selectedBox === 'notifications' ? 'selected' : ''}`} onClick={() => handleStatClick('notifications')}>
                                                    <h5 className="proactive-notifications"><b>Notifications</b></h5>
                                                    <h4 className="proactive-notifications"><b>{notificationStatistics ? (notificationStatistics.pending.by_action.Notifications || 0) : 0}</b></h4>
                                                </div>
                                                <div className={`notification-status-box ${selectedBox === 'newType' ? 'selected' : ''}`} onClick={() => handleStatClick('newType')}>
                                                    <h5 className="proactive-new-types"><b>New Types</b></h5>
                                                    <h4 className="proactive-new-types"><b>{notificationStatistics ? (notificationStatistics.pending.by_action.NewAction || 0) : 0}</b></h4>
                                                </div>
                                            </div>
                                            :
                                            <div className="d-flex border p-1 justify-content-around">
                                                <div className={`notification-status-box ${selectedBox === 'total' ? 'selected' : ''}`} onClick={() => handleStatClick('total')}>
                                                    <h5 className="proactive-total-notifications"><b>Total Alerts</b></h5>
                                                    <h4 className="proactive-total-notifications"><b>{notificationStatistics ? notificationStatistics.complete.total : 0}</b></h4>
                                                </div>
                                                <div className={`notification-status-box ${selectedBox === 'tickets' ? 'selected' : ''}`} onClick={() => handleStatClick('tickets')}>
                                                    <h5 className="proactive-tickets"><b>Tickets</b></h5>
                                                    <h4 className="proactive-tickets"><b>{notificationStatistics ? (notificationStatistics.complete.by_action.Ticket || 0) : 0}</b></h4>
                                                </div>
                                                <div className={`notification-status-box ${selectedBox === 'tasks' ? 'selected' : ''}`} onClick={() => handleStatClick('tasks')}>
                                                    <h5 className="proactive-tasks"><b>Tasks</b></h5>
                                                    <h4 className="proactive-tasks"><b>{notificationStatistics ? (notificationStatistics.complete.by_action.Task || 0) : 0}</b></h4>
                                                </div>
                                                <div className={`notification-status-box ${selectedBox === 'notifications' ? 'selected' : ''}`} onClick={() => handleStatClick('notifications')}>
                                                    <h5 className="proactive-notifications"><b>Notifications</b></h5>
                                                    <h4 className="proactive-notifications"><b>{notificationStatistics ? (notificationStatistics.complete.by_action.Notifications || 0) : 0}</b></h4>
                                                </div>
                                            </div>
                                    }
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>
            </div>
            <Row className="mb-2 align-items-center mt-1">
                {activeTab != 'today' && (
                    <Col md={12} className="d-flex justify-content-end align-items-center">

                        {/* Left Side */}

                        <div className="d-flex mr-2">
                            <Input
                                type="text"
                                className="w-100 mr-2"
                                value={globalSearch}
                                onChange={(e) => setGlobalSearch(e.target.value)}
                                placeholder="Search the alert"
                            />

                            <Button
                                className='btn-background-color-Proceed-gallery'
                                // disabled={!globalSearch}
                                onClick={handleSearchAction}>
                                Submit
                            </Button>
                        </div>

                        {/* Right Side */}

                        <GridPagination
                            pageSize={pagination.pageSize}
                            totalRecords={pagination.totalCount}
                            currentPageProp={page - 1}
                            disabled={loadScreen}
                            onPageChange={({ currentPage }) => {
                                setPage(currentPage + 1);
                            }}
                        />


                    </Col>
                )}
            </Row>

            {/* SCROLLABLE CONTENT SECTION (Tables) */}
            <div style={{
                flexGrow: 1,
                overflowY: 'auto',
                overflowX: 'hidden',
                minHeight: 0
            }}>
                <LoadingOverlay
                    active={loadScreen}
                    spinner={<Loader active type="ball-pulse" />}
                    text="Loading Alerts......"
                    styles={{
                        overlay: (base) => ({
                            ...base,
                            background: '#f1f4f6',
                            opacity: 1,
                        }),
                        content: (base) => ({
                            ...base,
                            color: '#000',
                        }),
                    }}
                >
                    <Row className="align-items-center">
                        <Col md={12} className="mt-3 d-flex justify-content-end">
                            {!["complete", "pending"].includes(activeTab) && (
                                <div
                                    className="bulk-creation-button d-flex justify-content-center align-items-center mr-3"
                                    onClick={() => handleConfrimationPopup()}
                                    role="button"
                                >
                                    Bulk Creation
                                </div>
                            )}
                        </Col>
                    </Row>

                    {activeTab && activeTab != 'complete' &&
                        (
                            <div ref={newTypesRef} style={{ scrollMarginTop: '5px' }}>
                                <ProactiveMonitoringOtherTypes
                                    activeTab={activeTab}
                                    allAmazonAlertsData={allAmazonAlertsData}
                                    newTypeData={newTypeData}
                                    setAllAmazonAlertsData={setAllAmazonAlertsData}
                                />
                            </div>)}
                    <div ref={ticketsRef} style={{ scrollMarginTop: '5px' }}>
                        <ProactiveMonitoringTickets
                            handleTableFieldChange={handleTableFieldChange}
                            getSubTypesByPathway={props.getSubTypesByPathway}
                            activeTab={activeTab}
                            allAmazonAlertsData={allAmazonAlertsData}
                            ticketsData={ticketsData}
                            setTicketsData={setTicketsData}
                            setAllAmazonAlertsData={setAllAmazonAlertsData}
                            problemAreaList={problemAreaList}
                            subRequestTypesList={subRequestTypesList}
                            problemAreaPathwayList={problemAreaPathwayList}
                        /></div>
                    <div ref={tasksRef} style={{ scrollMarginTop: '5px' }}>
                        <ProactiveMonitoringTasks
                            activeTab={activeTab}
                            allAmazonAlertsData={allAmazonAlertsData}
                            setAllAmazonAlertsData={setAllAmazonAlertsData}
                            tasksData={tasksData}
                            setTasksData={setTasksData}
                            teamMemberList={teamMembers}
                            loggedInUserId={loggedInUserId}
                        /></div>
                    <div ref={notificationsRef} style={{ scrollMarginTop: '5px' }}>
                        <ProactiveMonitoringNotifications
                            activeTab={activeTab}
                            allAmazonAlertsData={allAmazonAlertsData}
                            setAllAmazonAlertsData={setAllAmazonAlertsData}
                            notificationsData={notificationsData}
                            setNotificationsData={setNotificationsData}
                        /></div>

                </LoadingOverlay>
            </div>

            {/* MODALS */}
            <CustomModal
                isOpen={bulkCreateConfirmationsPopup}
                toggle={() => setBulkCreateConfirmationsPopup(!bulkCreateConfirmationsPopup)}
                size="lg"
                header="Bulk Action Create Confirmation"
                className="curve-popup"
            >
                <Card className="curve-popup p-3">
                    <Row>
                        <Col md={12}>
                            <h5><b>Statistics for Today's Alerts</b></h5>
                            <h6><b>Ready for Action : </b></h6>
                            <h6>Tickets : {counts.tickets}</h6>
                            <h6>Tasks : {counts.tasks}</h6>
                            <h6>Notifications : {counts.notifications}</h6>
                            <h6><b>Remaining Alerts : </b></h6>
                            <h6>New alert types : {counts.newType}</h6>
                        </Col>
                        <Col md={12} className="d-flex justify-content-end mt-4">
                            <Button
                                className="btn-background-color-Proceed-gallery "
                                disabled={
                                    ((counts.tickets || 0) + (counts.tasks || 0) + (counts.notifications || 0) === 0)
                                }
                                onClick={() => handleBulkCreation()}
                            >
                                Bulk Create
                            </Button>
                            <Button
                                className="ml-2 btn-background-color-cancle"
                                onClick={() => setBulkCreateConfirmationsPopup(false)}
                            >
                                Cancel
                            </Button>
                        </Col>
                    </Row>
                </Card>
            </CustomModal>

            <CustomModal
                isOpen={openNotificationSetting}
                toggle={() => { setOpenNotificationSetting(!openNotificationSetting); setOpenNotificationSetting(false); }}
                size={"xl"}
                header={'Action Settings'}
                className="curve-popup"
            >
                <Card className="curve-popup p-3 ">

                    <NotificationSettings
                        setAllAmazonAlertsData={props.setAllAmazonAlertsData}
                        setOpenNotificationSetting={setOpenNotificationSetting}
                        activeTab={activeTab}
                        problemAreaList={problemAreaList}
                        problemAreaPathwayList={problemAreaPathwayList} n
                        subRequestTypesList={subRequestTypesList}
                        allNotificationSettings={allNotificationSettings}
                        setAllNotificationSettings={setAllNotificationSettings} />
                </Card>
            </CustomModal>
            <CustomModal
                isOpen={showImportForm}
                toggle={() => setShowImportForm(!showImportForm)}
                size={"lg"}
                header={'Proactive Monitoring - Amazon Alerts'}
                className="curve-popup"
            >
                <Row className="mb-1">
                    <Col md={12}>
                        <FormGroup tag="fieldset">
                            <legend>Choose Import Method:</legend>
                            <FormGroup check inline>
                                <Label check>
                                    <Input type="radio" name="importMethod" value="text" checked={importMethod === 'text'} onChange={(e) => { setImportMethod(e.target.value); setFileErrorMessage(""); }} />
                                    Paste JSON Text
                                </Label>
                            </FormGroup>
                            <FormGroup check inline>
                                <Label check>
                                    <Input type="radio" name="importMethod" value="file" checked={importMethod === 'file'} onChange={(e) => { setImportMethod(e.target.value); setFileErrorMessage(""); }} />
                                    Upload JSON File
                                </Label>
                            </FormGroup>
                        </FormGroup>
                    </Col>
                </Row>
                {importMethod === 'text' && (
                    <FormGroup>
                        <Label for="jsonInput">Paste JSON data:</Label>
                        <Input type="textarea" id="jsonInput" value={jsonInput} onChange={(e) => setJsonInput(e.target.value)} rows={8} placeholder="Paste your JSON data here..." />
                        {fileErrorMessage && (
                            <p className="mt-2" style={{ color: 'red', fontSize: '12px' }}>
                                {fileErrorMessage}
                            </p>
                        )}
                    </FormGroup>
                )}
                {importMethod === 'file' && (
                    <FormGroup>
                        <Label for="fileInput" className="mb-3">Select JSON file:</Label>

                        <div className="row align-items-start">
                            {/* Left Column: Upload Area */}
                            <div className="col-md-6">
                                <div
                                    className="dotted-box-upload-product p-3 text-center"
                                    onDrop={handleDrop}
                                    onDragOver={(e) => e.preventDefault()}
                                    style={{ border: '2px dashed #ccc', borderRadius: '10px', cursor: 'pointer', minHeight: '120px' }}
                                    onClick={() => document.getElementById("fileInput").click()}
                                >
                                    <FontAwesomeIcon icon={faCloudUploadAlt} style={{ fontSize: "24px", color: '#B2A1FF' }} />
                                    <p className='mt-2 mb-0' style={{ fontSize: '13px' }}>
                                        Drag & Drop JSON files here or <b>Browse</b>
                                    </p>
                                    <input
                                        type="file"
                                        id="fileInput"
                                        accept=".json"
                                        onChange={handleFileSelect}
                                        multiple
                                        style={{ display: "none" }}
                                    />
                                </div>

                                {/* Error Message stays tucked under the box */}
                                {fileErrorMessage && (
                                    <p className="mt-2" style={{ color: 'red', fontSize: '12px' }}>
                                        {fileErrorMessage}
                                    </p>
                                )}
                            </div>

                            {/* Right Column: File List */}
                            <div className="col-md-6 mt-3 mt-md-0">
                                <p style={{ fontSize: "13px", fontWeight: 'bold' }} className="mb-2">Attached File List</p>
                                <ul style={{
                                    color: "green", fontSize: "13px", paddingLeft: '0', listStyle: 'none', borderLeft: '1px solid #eee', paddingLeft: '15px', maxHeight: '150px', overflowY: 'auto'
                                }}>
                                    {selectedFile.length > 0 ? (
                                        selectedFile.map((file, index) => (
                                            <li key={index} className="d-flex align-items-center justify-content-between mb-2">
                                                <span className="text-truncate" title={file.name}>
                                                    {file.name} <small className="text-muted">({formatFileSize(file.size)})</small>
                                                </span>
                                                <button
                                                    type="button"
                                                    className="btn p-0 ml-2 mr-1"
                                                    style={{ border: 'none', background: 'none' }}
                                                    onClick={(e) => { e.stopPropagation(); removeFile(index); }}
                                                >
                                                    <FontAwesomeIcon color="red" icon={faWindowClose} />
                                                </button>
                                            </li>
                                        ))
                                    ) : (
                                        <li style={{ color: '#999', fontStyle: 'italic' }}>No files attached</li>
                                    )}
                                </ul>
                            </div>
                        </div>
                    </FormGroup>
                )}


                <div className="mt-3">
                    <Button color="brand-blue-dark" onClick={handleJsonImport}>{importMethod === 'text' ? 'Import from Text' : 'Import from File'}</Button>
                    <Button color="secondary" className="ml-2" onClick={clearImportForm}>Cancel</Button>
                </div>
            </CustomModal>

            <CustomModal
                isOpen={importResultModal}
                toggle={handleCloseImportResult}
                size={"md"}
                header={importResultDetails.title}
                className="curve-popup"
            >
                <Card className="curve-popup p-1 mb-0" style={{ border: 'none' }}>
                    <div className="text-center">
                        {/* Status Icons */}
                        {importResultDetails.type === 'success' && (
                            <div className="mb-3 text-success" style={{ fontSize: '3rem' }}>
                                <i className="fa fa-check-circle" aria-hidden="true"></i>
                            </div>
                        )}
                        {importResultDetails.type === 'warning' && (
                            <div className="mb-3 text-warning" style={{ fontSize: '3rem' }}>
                                <i className="fa fa-exclamation-triangle" aria-hidden="true"></i>
                            </div>
                        )}
                        {importResultDetails.type === 'error' && (
                            <div className="mb-3 text-danger" style={{ fontSize: '3rem' }}>
                                <i className="fa fa-times-circle" aria-hidden="true"></i>
                            </div>
                        )}

                        {/* Dynamic Message Mapping */}
                        <div className="mt-2">
                            {importResultDetails.messages.map((msg, index) => {
                                const isBullet = msg.startsWith('•');
                                const isErrorHeader = msg.includes('Invalid JSON syntax');

                                return (
                                    <h5
                                        key={index}
                                        className={isBullet ? "mb-1" : "mb-3"}
                                        style={{
                                            lineHeight: '1.5',
                                            textAlign: isBullet ? 'left' : 'center',
                                            fontSize: isBullet ? '0.95rem' : '1.1rem',
                                            fontWeight: (isBullet || isErrorHeader) ? 'bold' : 'normal',
                                            paddingLeft: isBullet ? '20px' : '0',
                                            color: isErrorHeader ? '#d9534f' : 'inherit'
                                        }}
                                    >
                                        {msg}
                                    </h5>
                                );
                            })}
                        </div>

                        <Button
                            color="primary"
                            className="mt-4 px-5"
                            style={{ borderRadius: '20px' }}
                            onClick={handleCloseImportResult}
                        >
                            {shouldReloadOnClose ? "Close" : "Close"}
                        </Button>
                    </div>
                </Card>
            </CustomModal>

        </div>
    );
};

const mapStateToProps = state => ({
    token: state.loggedUser.token,
});

export default connect(mapStateToProps)(ProactiveMonitoringMainPage);